export function formatApproxHours(raw?: string | null): string | null {
  if (!raw?.trim()) return null;
  const range = raw.match(/(\d+(?:\.\d+)?)\s*[-–—]\s*(\d+(?:\.\d+)?)/);
  if (range) return `≈ ${range[1]}–${range[2]} hours`;
  const n = raw.match(/(\d+(?:\.\d+)?)/);
  if (n) return `≈ ${n[1]} hours`;
  return `≈ ${raw.trim()} hours`;
}

export function projectAudienceLabel(teamType?: string | null): string {
  return /group|team/i.test(teamType || '')
    ? 'Ideal for a team project'
    : 'Ideal for an individual project';
}

export function splitTechStack(raw?: string | null): string[] {
  return (raw || '')
    .split(',')
    .map((item) => item.trim())
    .filter(Boolean);
}

export function truncateTechStack(raw: string, max = 30): { preview: string; truncated: boolean } {
  const text = raw.trim();
  if (text.length <= max) return { preview: text, truncated: false };
  return { preview: `${text.slice(0, max).trimEnd()}...`, truncated: true };
}
